//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Editor from '@/components/Editor/index'
import ComponentList from '@/components/ComponentList' // 左侧列表组件
import AttrList from '@/components/AttrList' // 右侧属性列表
import AnimationList from '@/components/AnimationList' // 右侧动画列表
import EventList from '@/components/EventList' // 右侧事件列表
import componentList from '@/custom-component/component-list' // 左侧列表数据
import Toolbar from '@/components/Toolbar'
import { deepCopy } from '@/utils/utils'
import { mapState } from 'vuex'
import generateID from '@/utils/generateID'
import { initID } from '@/utils/generateID'
import { listenGlobalKeyDown } from '@/utils/shortcutKey'

export default {
    components: { Editor, ComponentList, AttrList, AnimationList, EventList, Toolbar },
    data() {
        return {
            activeName: 'attr',
            reSelectAnimateIndex: undefined,
            loading: false,
            isShowPreview: false,
            lineBar: {
                "x": ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                "y": [150, 230, 224, 218, 135, 147, 260],
            },
            pie: {
                "data": [{ "name": "Search", "value": 1048 }, { "name": "Direct", "value": 735 }, { "name": "Email", "value": 580 }]
            },
            gauge: {
                "data": [{ "name": "SCORE", "value": 50 }]
            },
            LineUPG: {
                "x": ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                "data": [{ "name": "line77", "data": [0, 176, 33, 173, 186, 164, 100] },
                { "name": "line55", "data": [73, 196, 59, 120, 154, 171, 154] },
                { "name": "line19", "data": [49, 42, 65, 20, 180, 94, 40] },
                { "name": "line62", "data": [8, 181, 8, 170, 14, 6, 0] },
                { "name": "line44", "data": [89, 126, 112, 81, 150, 119, 174] },
                { "name": "line80", "data": [88, 171, 163, 54, 0, 62, 56] },
                { "name": "line41", "data": [46, 49, 194, 164, 30, 155, 40] }]
            },
            Sector: {
                data: [ { value: 1048, name: 'Search Engine' },{ value: 735, name: 'Direct' },{ value: 580, name: 'Email' },{ value: 484, name: 'Union Ads' },{ value: 300, name: 'Video Ads' },]
            }
        }
    },
    computed: mapState([
        'componentData',
        'curComponent',
        'isClickComponent',
        'canvasStyleData',
        'editor',
    ]),
    created() {
        var token = this.$route.query.A
        if (token) {
            this.$store.commit('SET_STATUS', token)
            var id = this.$route.query.I
            if (id) {
                this.getComponentData(id)
            } else {
                this.restore()
                initID(this.componentData)
            }
            // 全局监听按键事件
            listenGlobalKeyDown()
        }
    },
    methods: {
        restore() {
            // 用保存的数据恢复画布
            if (localStorage.getItem('canvasData')) {
                // this.$store.commit('setComponentData', this.resetID(JSON.parse(localStorage.getItem('canvasData'))))
                this.$store.commit('setComponentData', JSON.parse(JSON.parse(localStorage.getItem('canvasData'))))
            }

            // if (localStorage.getItem('canvasStyle')) {
            //     // console.log(JSON.stringify(localStorage.getItem('canvasStyle')))
            //     this.$store.commit('setCanvasStyle', JSON.parse(localStorage.getItem('canvasStyle')))
            // }
        },

        resetID(data) {
            data.forEach(item => {
                item.id = generateID()
            })
            return data
        },

        handleDrop(e) {
            e.preventDefault()
            e.stopPropagation()
            const index = e.dataTransfer.getData('index')
            const rectInfo = this.editor.getBoundingClientRect()
            // console.log(index)
            if (index) {
                const component = deepCopy(componentList[index])
                component.style.top = e.clientY - rectInfo.y
                component.style.left = e.clientX - rectInfo.x
                component.id = generateID()
                // 文本框
                if (index == 0 || index == 6 || index == 7 || index == 8 || index == 9 || index == 10 || index == 11) {
                    component.events.subscribe = false
                    component.events.subscribeTopic = 'topic' + component.id
                    if (index == 7) {
                        component.events.example = JSON.stringify(this.pie, null, 6)
                        component.events.row = 17
                    }
                    else if (index == 9) {
                        component.events.example = JSON.stringify(this.gauge, null, 6)
                        component.events.row = 23
                    } else if (index == 10) {
                        component.events.example = JSON.stringify(this.LineUPG, null, 6)
                        component.events.row = 23
                    } else if (index == 11) {
                        component.events.example = JSON.stringify(this.Sector, null, 6)
                        component.events.row = 23
                    }
                    else {
                        component.events.example = JSON.stringify(this.lineBar, null, 6)
                        component.events.row = 20
                    }
                }
                else if (index == 1) {
                    // 按钮
                    component.events.publish = false
                    component.events.publishTopic = 'topic' + component.id
                    component.events.publishPayload = ''
                    component.events.publishComponents = []
                    component.style.className = ''
                }
                this.$store.commit('addComponent', { component })
                this.$store.commit('recordSnapshot')
            }
        },

        handleDragOver(e) {
            e.preventDefault()
            e.dataTransfer.dropEffect = 'copy'
        },

        handleMouseDown(e) {
            e.stopPropagation()
            this.$store.commit('setClickComponentStatus', false)
            this.$store.commit('setInEditorStatus', true)
        },

        deselectCurComponent(e) {
            if (!this.isClickComponent) {
                this.$store.commit('setCurComponent', { component: null, index: null })
            }

            // 0 左击 1 滚轮 2 右击
            if (e.button != 2) {
                this.$store.commit('hideContextMenu')
            }
        },

        getComponentData(id) {
            this.loading = true
            this.request({
                url: '/web/preview/' + id,
                method: 'get',
            }).then(response => {
                let result = response.result
                this.$store.commit('setComponentData', JSON.parse(result.substring(1, result.length - 1)))
                initID(this.componentData)
                this.loading = false
            }).catch(error => {
                this.loading = false
                this.$message({
                    message: error.errmsg == undefined ? '页面解析异常' : error.errmsg,
                    type: 'error',
                    duration: 3 * 1000
                })
            })
           
        }
    },
}
